// extracted by mini-css-extract-plugin
export default {"product-form-select":"ProductFormSelect_product-form-select__K1y1b","label":"ProductFormSelect_label__eGSOb","highlighted":"ProductFormSelect_highlighted__X2b7C"};